// extracted by mini-css-extract-plugin
export default {"tooltip":"Po-z","sharingV2":"Qo-z","sharingIconsV2":"Ro-z","links":"So-z","link":"To-z","facebookV2":"Uo-z","twitterV2":"Vo-z","pinterestV2":"Wo-z"};